import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { bundle } from '../data/storeData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const SubscriptionPromo = ({ onAddToCart }) => {
  const [purchaseType, setPurchaseType] = useState('subscribe');
  const [isAdding, setIsAdding] = useState(false);

  const handleAdd = () => {
    setIsAdding(true);
    setTimeout(() => {
      onAddToCart({
        ...bundle,
        price: purchaseType === 'subscribe' ? Math.floor(bundle.price * 0.85) : bundle.price,
        name: purchaseType === 'subscribe' ? `${bundle.name} (Subscription)` : bundle.name
      });
      setIsAdding(false);
    }, 800);
  };

  return (
    <section className="py-24 md:py-40 bg-[#D4C5B9]/20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="bg-white flex flex-col lg:flex-row overflow-hidden shadow-sm">
          
          <div className="w-full lg:w-1/2 relative min-h-[500px]">
            <img 
              src={bundle.image} 
              alt={bundle.name}
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-stone-900/5" />
          </div>

          <div className="w-full lg:w-1/2 p-12 md:p-20 lg:p-24 flex flex-col justify-center">
            <span className="text-[11px] font-bold tracking-[0.3em] uppercase text-stone-400 mb-8 block">
              The Ultimate Routine
            </span>
            <h2 className="font-serif text-4xl md:text-5xl text-stone-900 mb-8">
              {bundle.name}
            </h2>
            <p className="text-stone-600 font-light leading-relaxed mb-12 text-lg">
              {bundle.description}
            </p>

            <div className="space-y-4 mb-12">
              <button 
                onClick={() => setPurchaseType('subscribe')}
                className={`w-full flex items-center gap-6 p-6 border transition-all duration-300 text-left
                  ${purchaseType === 'subscribe' ? 'border-stone-900 bg-stone-50' : 'border-stone-200 hover:border-stone-400'}`}
              >
                <div className={`w-4 h-4 rounded-full border flex items-center justify-center
                  ${purchaseType === 'subscribe' ? 'border-stone-900 bg-stone-900' : 'border-stone-300'}`}>
                  {purchaseType === 'subscribe' && <div className="w-1.5 h-1.5 bg-white rounded-full" />}
                </div>
                <div className="flex-grow">
                  <span className="block text-xs font-bold uppercase tracking-widest">Subscribe & Save 15%</span>
                  <span className="block text-[10px] text-stone-500 mt-1 uppercase tracking-widest">Delivered every 60 days • Skip anytime</span>
                </div>
                <span className="font-serif text-xl">${Math.floor(bundle.price * 0.85)}</span>
              </button>

              <button 
                onClick={() => setPurchaseType('one-time')}
                className={`w-full flex items-center gap-6 p-6 border transition-all duration-300 text-left
                  ${purchaseType === 'one-time' ? 'border-stone-900 bg-stone-50' : 'border-stone-200 hover:border-stone-400'}`}
              >
                <div className={`w-4 h-4 rounded-full border flex items-center justify-center
                  ${purchaseType === 'one-time' ? 'border-stone-900 bg-stone-900' : 'border-stone-300'}`}>
                  {purchaseType === 'one-time' && <div className="w-1.5 h-1.5 bg-white rounded-full" />}
                </div>
                <div className="flex-grow">
                  <span className="block text-xs font-bold uppercase tracking-widest">One-Time Purchase</span>
                </div>
                <div className="text-right">
                  <span className="block text-stone-400 line-through text-[10px] tracking-widest">${bundle.originalPrice}</span>
                  <span className="block font-serif text-xl">${bundle.price}</span>
                </div>
              </button>
            </div>

            <button 
              onClick={handleAdd}
              disabled={isAdding}
              className="w-full bg-stone-900 text-white py-5 text-xs font-bold tracking-[0.2em] uppercase hover:bg-stone-800 transition-all flex items-center justify-center gap-3"
            >
              {isAdding ? (
                <>
                  <SafeIcon icon={FiIcons.FiLoader} className="w-4 h-4 animate-spin" />
                  Updating Bag...
                </>
              ) : (
                'Add Ritual to Bag'
              )}
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default SubscriptionPromo;